const adaptIndicacionByIdEvaluacion = (valorEsperado) => {
  const {
    idIndicacion,
    idInsumo,
    idEvaluacion,
    idEstado,
    estado,
    fechaDesde,
    fechaHasta,
    fechaAlta,
    solicitudEnCurso
  } = valorEsperado;

  return {
    idIndicacion,
    idInsumo,
    idEvaluacion,
    idEstado,
    estado,
    fechaDesde,
    fechaHasta,
    fechaAlta,
    solicitudEnCurso
  }
};
export const adaptIndicacionesByIdEvaluacion = (data) => {
  return (
    data?.indicacionesByIdEvaluacion?.valorEsperado?.map((indicacion) =>
      adaptIndicacionByIdEvaluacion(indicacion)
    ) || []
  );
};
